import { CS } from "../../../base/utils/styler";

export const baseStyle: CS = {
    display: 'flex',
    flexDirection: 'row',
    gap: '5px',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '16px',
    fontSize: '14px',
    color: '#3d3d3d',
    position: 'fixed',
    top: '10px',
    left: '10px',

}

export const dotStyle: CS = {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    backgroundColor: '#eee',
    '&.success': {
        background: '#00b028',
    },
    '&.error': {
        background: '#ed4f5e',
    },
}

export const messageStyle: CS = {
}




